import { SharedLocale, type SharedLocalizedString } from "../SharedLocale.js";

export const careersPathMap = {
	[SharedLocale.cs]: "kariera",
	[SharedLocale.en]: "careers",
	[SharedLocale.pl]: "kariera",
	[SharedLocale.sk]: "kariera",
} satisfies SharedLocalizedString;
